import { useEffect, useMemo, useState } from 'react';
import type { TableData } from '@/components/custom/erp/data-table-v2';
import { SoChiTietCongNoNhieuKhachHangItem } from '@/types/schemas';

export interface UseTableDataReturn {
  tables: TableData[];
  handleRowClick: (params: BanHangTableParams) => void;
}

export function useTableData(data: SoChiTietCongNoNhieuKhachHangItem[]): UseTableDataReturn {
  const columns = useMemo(
    () => [
      { field: 'select', headerName: '', width: 50 },
      { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
      { field: 'ten_kh', headerName: 'Tên khách hàng', width: 200 },
      { field: 'no_dk', headerName: 'Dư nợ đầu', width: 150, type: 'number', align: 'right' },
      { field: 'co_dk', headerName: 'Dư có đầu', width: 150, type: 'number', align: 'right' },
      { field: 'ps_no', headerName: 'Ps nợ', width: 150, type: 'number', align: 'right' },
      { field: 'ps_co', headerName: 'Ps có', width: 150, type: 'number', align: 'right' },
      { field: 'no_ck', headerName: 'Dư nợ cuối', width: 150, type: 'number', align: 'right' },
      { field: 'co_ck', headerName: 'Dư có cuối', width: 150, type: 'number', align: 'right' }
    ],
    []
  );

  const [tables, setTables] = useState<TableData[]>([
    {
      name: '',
      columns,
      rows: []
    }
  ]);

  useEffect(() => {
    setTables(prevTables => {
      if (prevTables[0].rows !== data) {
        return [
          {
            ...prevTables[0],
            rows: data
          }
        ];
      }
      return prevTables;
    });
  }, [data]);

  const handleRowClick = (_params: BanHangTableParams) => {
    // Handle row click logic here
  };

  return {
    tables,
    handleRowClick
  };
}
